export class DunningMail {
  title: string;
  text: string;
  due_in: number;

  constructor(v: Partial<DunningMail>) {
    this.title = v.title;
    this.text = v.text;
    this.due_in = v.due_in;
  }
}
